import { STORAGE_KEY_PREFIX, MAX_SEARCHES } from './constants';

export const getStorageKey = () => {
  const hostname = window.location.hostname; // e.g., "dub.beta.tumbler.oss.aws.dev"
  const parts = hostname.split('.'); // ['dub', 'beta', 'tumbler', 'oss', 'aws', 'dev']
  
  const region = parts[0]; // 'dub' or 'iad'
  const stage = parts[1];  // 'beta' or 'prod' or 'gamma'
  
  return `${STORAGE_KEY_PREFIX}_${region}_${stage}`;
};

export const getRecentSearches = (): string[] => {
  try {
    const searches = localStorage.getItem(getStorageKey());
    return searches ? JSON.parse(searches) : [];
  } catch {
    return [];
  }
};

export const addRecentSearch = (search: string): void => {
  // Input validation
  if (!search || typeof search !== 'string') {
    console.error('Invalid search input');
    return;
  }

  const searches = getRecentSearches();
  const updatedSearches = [
    search,
    ...searches.filter(s => s !== search)
  ].slice(0, MAX_SEARCHES);
  
  localStorage.setItem(getStorageKey(), JSON.stringify(updatedSearches));
};

export const clearRecentSearches = (): void => {
  localStorage.removeItem(getStorageKey());
};